import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * Display Properties — the Control Panel applet behind Desktop ▸ right-click ▸
 * Properties. It is deliberately *not* a `dialog`: XP gave it a real taskbar
 * button and let you switch away from it. It is not resizable either, which is
 * how the property sheet behaved.
 *
 * Args:
 *   tab  'themes' | 'desktop' | 'screensaver' | 'appearance' | 'settings'
 *        Opens straight onto that page. Defaults to Themes, as XP did.
 */
export const displayApp: AppManifest = {
  id: 'display',
  name: 'Display Properties',
  icon: '/assets/icons/display.svg',
  component: lazy(() => import('./DisplayProperties')),

  defaultSize: { w: 420, h: 500 },
  resizable: false,
  maximizable: false,
  singleton: true,

  group: 'System',
  titleFor: () => 'Display Properties',
};
